/*
 * @Author: chaoluandi chaoluandi@whty.com.cn
 * @Date: 2024-11-27 19:11:37
 * @LastEditors: chaoluandi chaoluandi@whty.com.cn
 * @LastEditTime: 2024-11-28 17:57:27
 * @FilePath: /after-school-services/src/utils-khfw/assbeToken.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import axios from 'axios';
import { handleLocalUrl } from "././../utils-khfw/getBaseUrl.js";
import BetterStorage from './betterStorage.service.js';
import { PLATFORM_OPEN_API, PLATFORM_OPEN_APP_ID } from '../config/app.config.js';
import CryptoJS from 'crypto-js';
const betterStorage = new BetterStorage();
const appId = "5txk2cf684cj6x7b28r6darkt38tr4jw"
// const appId = "n5e5essafdawzetb5cabjccpzi7i7yj3"
const appKey = "2dn2j53nyrw7miz3asfxh68nexp7kfmj"

export async function getAccessToken() {
    let accessToken = betterStorage.get('accessToken');
    let baseURL= await handleLocalUrl()
    if (!accessToken) {
        let timeStamp = new Date().getTime();
        let message = appId + appKey + timeStamp;
        let hash = CryptoJS.HmacSHA1(message, appKey);
        let keyInfo = hash.toString(CryptoJS.enc.Hex)
        // console.log('打印参数--------getAccessToken',JSON.stringify({
        //     "timeStamp": timeStamp,
        //     "appId": appId,
        //     "keyInfo": keyInfo
        // }));
        const { data: { retCode, tokenInfo } = {} } = await axios({
            // url: `${PLATFORM_OPEN_API}/apigateway/getAccessToken`,
            url: `${baseURL}/apigateway/getAccessToken`,
            method: 'post',
            data: JSON.stringify({
                "timeStamp": timeStamp,
                "appId": appId,
                "keyInfo": keyInfo
            }),
            headers: {"Content-Type": "application/json; charset=utf-8"}
        });
        if (retCode === '000000') {
            betterStorage.set('accessToken', tokenInfo.accessToken, 90 * 60 * 1000);
            accessToken = tokenInfo.accessToken;
            console.log('获取accessToken',baseURL,accessToken);
        }
    }
    return accessToken;
}

